import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { PdfJsViewerModule } from "ng2-pdfjs-viewer";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { NgxMasonryModule } from "ngx-masonry";
import { AuthCamerallaInterceptor } from "src/app/auth/interceptors/auth.interceptor";
import { ErrorCamerallaInterceptor } from "src/app/auth/interceptors/error.interceptor";
import { CoreModule } from "src/app/core/core.module";
import { DefaultLayoutModule } from "src/app/core/layouts/default-layout/default-layout.module";
import { DigitalLayoutModule } from "src/app/shared/layouts/digital-layout/digital-layout.module";
import { SharedPipeModule } from "src/app/shared/pipes/shared.pipe.module";
import { SharedModule } from "src/app/shared/shared.module";
import { AdvertisingService } from "../../shared/services/advertising.service";
import { CTableModule } from "src/app/core/ui/c-table/c-table.module";
import { DemoMaterialModule } from "../administrator/material-module";
import { ExploreModule } from "../explore/explore.module";
import { LikeService } from "../photo/services/like.service";
import { RatingService } from "../photo/services/rating.service";
import {
  CopyLinkColComponent,
  DigitalLogActionColComponent,
  DigitalMemoryLogListComponent,
  DuplicateConfirmPopupComponent,
  MailPopupComponent,
  RenamePopupComponent,
  ReportPopupComponent,
  ShipGalleryComponent,
} from "./components";
import { ExpiryDateColComponent } from "./components/expiry-date-col/expiry-date-col.component";
import { DownloadProgressComponent } from "./components/file-detail/components/download-progress/download-progress.component";
import { ErrorPopupComponent } from "./components/file-detail/components/error-popup/error-popup.component";
import { PreviewPopupComponent } from "./components/file-detail/components/preview-popup/preview-popup.component";
import { PreviewStatusPopupComponent } from "./components/preview/preview-status-popup/preview-status-popup.component";
import { PreviewSubscriptionComponent } from "./components/preview/preview-subscription/preview-subscription.component";
import { PreviewStripeCheckoutComponent } from "./components/preview/preview-stripe-checkout/preview-stripe-checkout.component";
import { PreviewAccessComponent } from "./components/preview/preview-access/preview-access.component";
import { FileDetailComponent } from "./components/file-detail/file-detail.component";
import { PreviewComponent } from "./components/preview/preview.component";
import { TabAnimalAndPoisComponent } from "./components/travel-kit-modify/tab-animal-and-pois/tab-animal-and-pois.component";
import { TabBenefitsAndOffersComponent } from "./components/travel-kit-modify/tab-benefits-and-offers/tab-benefits-and-offers.component";
import { TabBrandMaterialsComponent } from "./components/travel-kit-modify/tab-brand-materials/tab-brand-materials.component";
import { TabCoursesComponent } from "./components/travel-kit-modify/tab-courses/tab-courses.component";
import { TabFilesComponent } from "./components/travel-kit-modify/tab-files/tab-files.component";
import { TabMediaComponent } from "./components/travel-kit-modify/tab-media/tab-media.component";
import { TabPhotosComponent } from "./components/travel-kit-modify/tab-photos/tab-photos.component";
import { TabVideosComponent } from "./components/travel-kit-modify/tab-videos/tab-videos.component";
import { TabWallpaperComponent } from "./components/travel-kit-modify/tab-wallpaper/tab-wallpaper.component";
import { TabRenewalPricingComponent } from "./components/travel-kit-modify/tab-renewal-pricing/tab-renewal-pricing.component";
import { TabNavigationControlsComponent } from "./components/travel-kit-modify/shared/tab-navigation-controls/tab-navigation-controls.component";
import { RichTextIsEmptyPipe } from "./components/travel-kit-modify/shared/rich-text-is-empty.pipe";
import { RichTextPlainLengthPipe } from "./components/travel-kit-modify/shared/rich-text-plain-length.pipe";
import { TravelKitRichTextEditorComponent } from "./components/travel-kit-modify/shared/travel-kit-rich-text-editor/travel-kit-rich-text-editor.component";
import { TravelKitModifyComponent } from "./components/travel-kit-modify/travel-kit-modify";
import { UnsavedChangesGuard } from "src/app/shared/services/guard-services/unsaved-changes-guard.service";
import { DigitalMemoryLogRoutingModule } from "./digital-memory-log-routing.module";
import { EmailTemplateComponent } from "./components/mail-popup/component/email-template.component";
import { MultiUploadComponent } from "./components/multi-upload/multi-upload.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DigitalMemoryLogRoutingModule,
    CoreModule,
    SharedModule,
    DigitalLayoutModule,
    NgxMasonryModule,
    PdfJsViewerModule,
    NgxExtendedPdfViewerModule,
    DemoMaterialModule,
    ExploreModule,
    DefaultLayoutModule,
    NgbModule,
    CTableModule,
    SharedPipeModule,
  ],
  exports: [],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthCamerallaInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorCamerallaInterceptor,
      multi: true,
    },
    RatingService,
    LikeService,
    AdvertisingService,
    UnsavedChangesGuard,
  ],
  entryComponents: [
    CopyLinkColComponent,
    DigitalLogActionColComponent,
    ExpiryDateColComponent,
    MailPopupComponent,
    RenamePopupComponent,
    DuplicateConfirmPopupComponent,
    ReportPopupComponent,
    PreviewPopupComponent,
    ErrorPopupComponent,
    PreviewStatusPopupComponent,
    PreviewSubscriptionComponent,
    PreviewStripeCheckoutComponent,
    PreviewAccessComponent,
  ],
  declarations: [
    CopyLinkColComponent,
    DigitalLogActionColComponent,
    ExpiryDateColComponent,
    DigitalMemoryLogListComponent,
    ShipGalleryComponent,
    TravelKitModifyComponent,
    TabBrandMaterialsComponent,
    TabCoursesComponent,
    TabFilesComponent,
    TabMediaComponent,
    TabPhotosComponent,
    TabVideosComponent,
    TabWallpaperComponent,
    TabNavigationControlsComponent,
    TravelKitRichTextEditorComponent,
    RichTextPlainLengthPipe,
    RichTextIsEmptyPipe,
    TabAnimalAndPoisComponent,
    TabBenefitsAndOffersComponent,
    TabRenewalPricingComponent,
    MailPopupComponent,
    RenamePopupComponent,
    PreviewComponent,
    FileDetailComponent,
    PreviewPopupComponent,
    DownloadProgressComponent,
    ErrorPopupComponent,
    PreviewStatusPopupComponent,
    PreviewSubscriptionComponent,
    PreviewStripeCheckoutComponent,
    PreviewAccessComponent,
    DuplicateConfirmPopupComponent,
    ReportPopupComponent,
    EmailTemplateComponent,
    MultiUploadComponent,
  ],
})
export class DigitalMemoryLogModule {}
